// Каталог фича-флагов с человеко-читаемыми названиями и описаниями.
// Ключи `code` синхронизированы с backend/prisma/plans.catalog.ts → FEATURES.
// Если добавляете новый флаг в бэкенде — продублируйте его здесь, чтобы
// оператор видел понятное название в редакторе тарифов.

export interface FeatureDef {
  code: string;
  name: string;
  description: string;
  /** Условная группа для визуальной разбивки редактора. */
  group: 'payments' | 'analytics' | 'content' | 'integrations' | 'support';
}

export const FEATURES_CATALOG: FeatureDef[] = [
  // ─── Платежи ──────────────────────────────────────────────────────
  {
    code: 'online_payments',
    name: 'Онлайн-оплата гостем',
    description:
      'YuKassa в электронном меню: гость оплачивает заказ картой со своего телефона. Без этого флага остаётся только оплата на месте.',
    group: 'payments',
  },

  // ─── Аналитика ────────────────────────────────────────────────────
  {
    code: 'advanced_analytics',
    name: 'Продвинутая аналитика',
    description:
      'Когорты, ABC-анализ блюд, почасовая выручка, отчёты по кассирам. На Start доступна только базовая сводка.',
    group: 'analytics',
  },
  {
    code: 'unlimited_history',
    name: 'История без ограничений',
    description:
      'Доступ к заказам за всё время. На Start автоматически обрезается до последних 90 дней.',
    group: 'analytics',
  },
  {
    code: 'export_reports',
    name: 'Экспорт отчётов',
    description: 'Выгрузка сводных и детальных отчётов в Excel и PDF одним кликом.',
    group: 'analytics',
  },
  {
    code: 'network_analytics',
    name: 'Аналитика по сети',
    description:
      'Консолидированные отчёты по всем заведениям владельца: сравнение, рейтинги, общая выручка.',
    group: 'analytics',
  },

  // ─── Контент и бренд ──────────────────────────────────────────────
  {
    code: 'white_label_menu',
    name: 'White-label меню',
    description:
      'Свой домен и лого на QR-меню, без упоминания Resstro. Для франшиз и сетей.',
    group: 'content',
  },

  // ─── Интеграции и безопасность ────────────────────────────────────
  {
    code: 'api_access',
    name: 'Публичный REST API',
    description:
      'HTTPS-доступ к заказам, меню и выручке для интеграций (1С, BI, собственный сайт).',
    group: 'integrations',
  },
  {
    code: 'audit_log',
    name: 'Аудит-лог действий',
    description:
      'Журнал всех действий сотрудников: кто открыл смену, изменил блюдо, отменил заказ.',
    group: 'integrations',
  },

  // ─── Поддержка ────────────────────────────────────────────────────
  {
    code: 'priority_support',
    name: 'Приоритетная поддержка',
    description: 'WhatsApp-чат с командой, SLA по времени первого ответа.',
    group: 'support',
  },
  {
    code: 'dedicated_manager',
    name: 'Персональный менеджер',
    description: 'Выделенный менеджер, SLA 99.9%, реакция до 1 часа, ночной дежурный.',
    group: 'support',
  },
];

export const FEATURE_GROUP_LABEL: Record<FeatureDef['group'], string> = {
  payments: 'Платежи',
  analytics: 'Аналитика и отчёты',
  content: 'Контент и бренд',
  integrations: 'Интеграции и безопасность',
  support: 'Поддержка',
};

export const FEATURE_GROUP_ORDER: FeatureDef['group'][] = [
  'payments',
  'analytics',
  'content',
  'integrations',
  'support',
];

export function getFeatureDef(code: string): FeatureDef | null {
  return FEATURES_CATALOG.find((f) => f.code === code) ?? null;
}
